var _excluded = ["columns", "expandable", "pageSize", "paginated", "rowExpanded", "rows", "selectable", "sort", "onSelect", "onExpand", "onSort", "onPageChange", "onVisibleRowsChange"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import isEqual from 'lodash.isequal';
import orderBy from 'lodash.orderby';
import some from 'lodash.some';
import PropTypes from 'prop-types';
import React from 'react';
import Paginator from '../Pagination/Paginator';
import SortableTable from './SortableTable';
export default class UncontrolledTable extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "sortedData", (rows, column, ascending) => orderBy(rows, [column], [ascending ? 'asc' : 'desc']));

    _defineProperty(this, "sortBy", (column, ascending) => {
      var sort;

      if (this.state.sort.column === column) {
        sort = {
          column,
          ascending
        };
      } else {
        sort = {
          column,
          ascending: true
        };
      }

      this.setState({
        sort
      }, () => this.props.onSort(sort));
    });

    _defineProperty(this, "toggleSelection", value => {
      var selected = this.state.selected;
      var newSelection = some(selected, value) ? selected.filter(selectedRow => !isEqual(selectedRow, value)) : [...selected, value];
      this.setState({
        selected: newSelection
      }, () => {
        this.props.onSelect(newSelection);
      });
    });

    _defineProperty(this, "toggleAll", () => {
      var newSelection = this.allSelected ? [] : this.props.rows;
      this.setState({
        selected: newSelection
      }, () => {
        this.props.onSelect(newSelection);
      });
    });

    _defineProperty(this, "toggleExpanded", value => {
      var expanded = this.state.expanded;
      var newExpanded = some(expanded, value) ? expanded.filter(expandedRow => !isEqual(expandedRow, value)) : [...expanded, value];
      this.setState({
        expanded: newExpanded
      }, () => this.props.onExpand(newExpanded));
    });

    _defineProperty(this, "setPage", page => {
      this.setState({
        page
      });
      this.props.onPageChange(page);
    });

    _defineProperty(this, "isEqualUsingKeys", (newArray, oldArray) => {
      var hasKey = element => element.key !== undefined;

      if (!(newArray.every(hasKey) && oldArray.every(hasKey))) {
        return newArray === oldArray;
      }

      var keys = oldArray.map(el => el.key).sort();
      var newKeys = newArray.map(el => el.key).sort();
      return isEqual(keys, newKeys);
    });

    _defineProperty(this, "getVisibleRows", () => {
      var page = this.state.page;
      var _this$state$sort = this.state.sort,
          ascending = _this$state$sort.ascending,
          column = _this$state$sort.column;
      var _this$props = this.props,
          paginated = _this$props.paginated,
          pageSize = _this$props.pageSize,
          rows = _this$props.rows;
      var start = page * pageSize;
      var end = start + pageSize;
      var sortedRows = this.sortedData(rows, column, ascending);
      return paginated ? sortedRows.slice(start, end) : sortedRows;
    });

    this.state = {
      sort: props.sort,
      expanded: props.expanded,
      selected: props.selected,
      page: props.page
    };
  }

  get allSelected() {
    return this.props.rows.length && this.state.selected.length === this.props.rows.length;
  }

  selected(value) {
    return some(this.state.selected, value);
  }

  expanded(value) {
    return some(this.state.expanded, value);
  }

  visibleRowsChanged(prevProps, prevState) {
    var page = this.state.page;
    var _this$state$sort2 = this.state.sort,
        ascending = _this$state$sort2.ascending,
        column = _this$state$sort2.column;
    var _this$props2 = this.props,
        paginated = _this$props2.paginated,
        pageSize = _this$props2.pageSize,
        rows = _this$props2.rows;
    var prevPage = prevState.page;
    var _prevState$sort = prevState.sort,
        prevAscending = _prevState$sort.ascending,
        prevColumn = _prevState$sort.column;
    var prevPaginated = prevProps.paginated,
        prevPageSize = prevProps.pageSize,
        prevRows = prevProps.rows;
    return page !== prevPage || ascending !== prevAscending || column !== prevColumn || paginated !== prevPaginated || pageSize !== prevPageSize || !this.isEqualUsingKeys(rows, prevRows);
  }

  componentDidMount() {
    this.props.onVisibleRowsChange(this.getVisibleRows());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var selectableChanged = nextProps.selectable !== this.props.selectable;
    var expandableChanged = nextProps.expandable !== this.props.expandable;
    var expandedChanged = !this.isEqualUsingKeys(this.props.expanded, nextProps.expanded);
    var selectedChanged = !this.isEqualUsingKeys(this.props.selected, nextProps.selected);
    var rowsChanged = !this.isEqualUsingKeys(this.props.rows, nextProps.rows); // Clear selection if rows or selectable change

    if (selectableChanged) {
      this.setState({
        selected: []
      });
    }

    if (rowsChanged || expandableChanged) {
      this.setState({
        expanded: []
      });
    }

    if (rowsChanged) {
      this.setState({
        page: 0
      });
    }

    if (selectedChanged) {
      this.setState({
        selected: nextProps.selected
      });
    }

    if (expandedChanged) {
      this.setState({
        expanded: nextProps.expanded
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.visibleRowsChanged(prevProps, prevState)) {
      this.props.onVisibleRowsChange(this.getVisibleRows());
    }
  }

  render() {
    var page = this.state.page;
    var _this$state$sort3 = this.state.sort,
        ascending = _this$state$sort3.ascending,
        column = _this$state$sort3.column;
    /* eslint-disable @typescript-eslint/no-unused-vars -- This will be resolved when this is a function component */

    var _this$props3 = this.props,
        columns = _this$props3.columns,
        expandable = _this$props3.expandable,
        pageSize = _this$props3.pageSize,
        paginated = _this$props3.paginated,
        _rowExpanded = _this$props3.rowExpanded,
        rows = _this$props3.rows,
        selectable = _this$props3.selectable,
        sort = _this$props3.sort,
        onSelect = _this$props3.onSelect,
        onExpand = _this$props3.onExpand,
        onSort = _this$props3.onSort,
        onPageChange = _this$props3.onPageChange,
        onVisibleRowsChange = _this$props3.onVisibleRowsChange,
        props = _objectWithoutProperties(_this$props3, _excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */


    var cols = columns.filter(col => !col.hidden).map(col => col.sortable !== false ? _objectSpread({
      active: column === col.key,
      ascending,
      onSort: asc => this.sortBy(col.key, asc)
    }, col) : col);
    var selectableProps = selectable ? {
      rowSelected: row => this.selected(row),
      onSelect: row => this.toggleSelection(row),
      onSelectAll: () => this.toggleAll(),
      allSelected: this.allSelected
    } : undefined;
    var expandableProps = expandable ? {
      rowExpanded: row => this.expanded(row) && _rowExpanded(row),
      onExpand: row => this.toggleExpanded(row)
    } : undefined;
    var visibleRows = this.getVisibleRows();
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SortableTable, _extends({}, props, {
      columns: cols,
      rows: visibleRows
    }, expandableProps, selectableProps)), paginated && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
      key: "separator"
    }), /*#__PURE__*/React.createElement(Paginator, {
      key: "paginator",
      currentPage: page + 1,
      onClick: pg => this.setPage(pg - 1),
      perPage: pageSize,
      totalItems: rows.length
    })));
  }

}

_defineProperty(UncontrolledTable, "propTypes", _objectSpread(_objectSpread({}, SortableTable.propTypes), {}, {
  expanded: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onExpand: PropTypes.func,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  selected: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  sort: PropTypes.shape({
    column: PropTypes.string,
    ascending: PropTypes.bool
  }),
  onSelect: PropTypes.func,
  onSort: PropTypes.func,
  onVisibleRowsChange: PropTypes.func
}));

_defineProperty(UncontrolledTable, "defaultProps", _objectSpread(_objectSpread({}, SortableTable.defaultProps), {}, {
  onExpand: () => {},
  expanded: [],
  onPageChange: () => {},
  page: 0,
  pageSize: 10,
  selected: [],
  sort: {
    ascending: true
  },
  onSelect: () => {},
  onSort: () => {},
  onVisibleRowsChange: () => {}
}));

UncontrolledTable.displayName = "UncontrolledTable";